import { render, staticRenderFns } from "./RingLoader.vue?vue&type=template&id=66afd028&scoped=true&"
import script from "./RingLoader.vue?vue&type=script&lang=js&"
export * from "./RingLoader.vue?vue&type=script&lang=js&"
import style0 from "./RingLoader.vue?vue&type=style&index=0&id=66afd028&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66afd028",
  null
  
)

export default component.exports